<template>
    <div class="container-with-shadow">
        <div>
            <b-tabs
                class="quest-mission-review-tab tab-content-with-pills-nav apprentice-pills-tab quest-missions-check-tab"
                v-model="activeTab"
                v-if="usermissions.length > 0"
                pills
                vertical
                nav-wrapper-class="col-12 col-md-3"
                content-class="col-md-9 quest-mission-review-content"
                @input="updateTabIndex">
                <template #tabs-start>
                    <div class="component-title">
                        <h5 class="title">{{ $t('quest.assignments') }}</h5>
                    </div>
                </template>

                <b-tab
                    v-for="usermission in usermissions"
                    v-if="usermission.status > 1"
                    :title="$t('quest.assignment')"
                    title-item-class="mission-tab-item"
                    title-link-class="mission-tab-item-link"
                    @click="selectMission(usermission.id)"
                    :key="usermission.id">
                    <template v-slot:title>
                        <div class="mission-name">
                            {{ usermission.mission.name }}
                            <div class="date">
                                <i class="fad fa-alarm-exclamation icon"></i
                                >{{ usermission.deadline.date | date_named_month_short }}
                            </div>
                        </div>
                    </template>

                    <div v-if="selectedMission != null">
                        <design-2021-quest-mission-user-review-component
                            :mission="usermission"
                            :badges="badges"
                            :quest-id="quest.id"
                            @callsavemission="saveMission"
                            @callunlockmission="unlockMission"
                            @calladdbadge="addBadge"
                            @calldeletebadge="deleteBadge">
                        </design-2021-quest-mission-user-review-component>
                    </div>
                </b-tab>
            </b-tabs>

            <div
                class="row"
                v-else>
                <div class="d-none d-md-block col-md-3">
                    <h4>{{ $t('quest.assignments') }}</h4>
                </div>
                <div class="col-12 col-md-9">
                    <div class="not-found with-header empty-mission-list">
                        <div class="icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-notice">
                            {{ $t('quest.this_student_has_no_submitted_assignments_yet') }}
                        </div>
                    </div>
                </div>
            </div>

            <b-modal
                id="mission-user-badge-modal"
                ref="mission-user-badge-modal"
                :title="$t('quest.choose_a_badge')"
                cancel-variant="outline-primary"
                :cancel-title="$t('common.cancel')"
                modal-class="apprentice-default-modal">
                <div class="badge-list">
                    <div
                        class="userbadge"
                        v-for="badge in badges">
                        <img
                            :src="badge.image"
                            @click="addBadge(badge.id)"
                            style="cursor: pointer" />
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';

Vue.use(Viewer);

export default {
    props: ['missionsIn', 'user', 'quest', 'badges', 'groupId'],
    name: 'design-2021-quest-user-review-component',
    data() {
        return {
            usermissions: this.missionsIn,
            selectedMission: this.missionsIn.length > 0 ? this.missionsIn[0] : null,
            activeTab: 0,
        };
    },
    methods: {
        updateTabIndex(tabIndex) {
            this.activeTab = tabIndex;
            localStorage.setItem('missionreviewTab', tabIndex);
            localStorage.setItem('missionreviewUser', this.user.id);
            localStorage.setItem('missionreviewRapport', this.quest.id);
            localStorage.setItem('missionreviewQuest', this.selectedMission.id);
        },

        statusStyle(mission) {
            return mission.status == 3 ? 'green' : 'orange';
        },

        selectMission(mission_id) {
            for (const mission of this.usermissions) {
                if (mission.id == mission_id) {
                    this.selectedMission = mission;
                }
            }
        },
        saveMission() {
            this.alert.saving();

            if (this.selectedMission.teacher == '' || this.selectedMission.teacher == null) {
                return this.alert.notice(
                    this.$t('quest.enter_score'),
                    this.$t('quest.enter_a_score_between_1_and_10_before_you_save_the_rating'),
                );
            }

            var data = {};
            data.id = this.selectedMission.id;
            data.teacher = this.selectedMission.teacher;
            data.bonus = this.selectedMission.bonus;
            data.comment = this.selectedMission.comment;

            this.axios.post(this.routes.questSaveUserMission(this.quest.id, this.selectedMission.user_id), data).then(
                (response) => {
                    this.selectedMission = response.data.usermission;

                    this.usermissions = this.usermissions.map(function (item) {
                        return item.id == response.data.usermission.id ? response.data.usermission : item;
                    });
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        unlockMission(mission_id) {
            this.alert
                .confirm(
                    this.$t('quest.reopen_assignment'),
                    this.$t('quest.are_you_sure_you_want_to_reopen_this_assignment'),
                    this.$t('common.yes_reopen'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        var data = {};
                        data.mission_id = mission_id;
                        data.user_id = this.user.id;

                        this.axios
                            .post(this.routes.questReopenMission(this.quest.id, this.selectedMission.user_id), data)
                            .then(
                                (response) => {
                                    this.alert.success();

                                    var count = this.usermissions.length;

                                    //remove mission from list
                                    this.usermissions = this.usermissions.filter(
                                        (mission) => mission.id !== mission_id,
                                    );

                                    if (count == 0) {
                                        //redirect to user list
                                        window.location.href = this.routes.questRapport(this.quest.id);
                                    } else {
                                        this.selectedMission = this.usermissions[0];
                                    }
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                    }
                });
        },
        deleteBadge(id) {
            this.alert
                .confirm(this.$t('quest.delete_badge'), this.$t('quest.are_you_sure_you_want_to_delete_this_badge'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        let data = {
                            id: this.selectedMission.id,
                        };

                        this.axios
                            .post(
                                this.routes.questDeleteUserBadge(this.quest.id, this.selectedMission.user_id, id),
                                data,
                            )
                            .then(
                                (response) => {
                                    this.selectedMission.badges = this.selectedMission.badges.filter(
                                        (badge) => badge.id !== id,
                                    );
                                    this.alert.success();
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                    }
                });
        },
        addBadge(id) {
            this.alert.saving();

            var data = {};
            data.id = this.selectedMission.id;
            data.badge_id = id;

            this.axios.post(this.routes.questAddUserBadge(this.quest.id, this.selectedMission.user_id), data).then(
                (response) => {
                    this.selectedMission.badges.push(response.data.badge);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    created() {
        if (localStorage.getItem('missionreviewTab') && localStorage.getItem('missionreviewTab') !== null) {
            if (
                localStorage.getItem('missionreviewUser') &&
                parseInt(localStorage.getItem('missionreviewUser')) === this.user.id &&
                localStorage.getItem('missionreviewRapport') &&
                parseInt(localStorage.getItem('missionreviewRapport')) === this.quest.id &&
                localStorage.getItem('missionreviewQuest')
            ) {
                this.activeTab = parseInt(localStorage.getItem('missionreviewTab'));
                this.selectMission(parseInt(localStorage.getItem('missionreviewQuest')));
            }
        }
    },
};
</script>

<style scoped lang="scss">
.quest-missions-check-tab ::v-deep {
    .nav {
        .component-title {
            padding: map-get($grid-gutter-spacing, 'fifteen');
            margin-bottom: map-get($grid-gutter-spacing, 'ten');
            background-color: var(--primary);
            color: $white;
            border-radius: 4px;
        }

        .mission-tab-item {
            .mission-tab-item-link {
                padding-left: map-get($grid-gutter-spacing, 'twenty-one');

                .mission-name {
                    display: flex;
                    flex-direction: column;

                    .date {
                        color: $text-muted-color;
                        font-weight: $font-weight-medium;

                        .icon {
                            color: $danger;
                            font-weight: $font-weight-bold;
                            font-size: $default-font-size;
                        }
                    }
                }
            }

            &:not(:last-child) {
                .mission-tab-item-link {
                    border-bottom: 3px dotted $border-color;
                }
            }
        }
    }
}

.quest-mission-review-tab > .nav-pills .mission-tab-item a {
    display: flex;
    align-content: center;
    justify-content: flex-start;
}

.quest-mission-review-tab > .nav-pills .mission-tab-item .mission-name {
    line-height: 1;
    display: flex;
    flex-direction: column;
}

.quest-mission-review-tab > .nav-pills .mission-name .date {
    font-size: 0.875rem;
    color: #686868;
}

.userbadge img {
    height: 60px;
    width: 60px;
}

.userbadge {
    margin: 10px;
    float: left;
}
</style>
